module.exports = __webpack_public_path__ + "static/media/ui-calendar.03b2a814.svg";